module.exports = __webpack_public_path__ + "img/GH-kyujin-marketing003.f707eb24.webp";